import { lazy } from "react";
import { styled } from "@mui/material";

const ApexChart = lazy(() => import('react-apexcharts'));

export const Chart = styled(ApexChart)``;